import React from 'react';
import '../style/homeLayout.css';

const HomeLayout = ({ children }) => {
  return <div className="home-layout">{children}</div>;
};

export default HomeLayout;